import type { DriverRecord, DriverSaveRequest } from './driver';

export type CustomerType = 'PERSON' | 'COMPANY';

export interface CustomerAccountDriverSummary {
  id: number;
  firstName: string;
  lastName: string;
  fullName: string;
  email?: string | null;
  phoneNumber?: string | null;
  driverLicenseNumber?: string | null;
  status: 'ACTIVE' | 'INACTIVE' | 'SUSPENDED' | 'BANNED';
}

export interface CustomerAccountRecord {
  id: number;
  type: CustomerType;
  displayName: string;
  legalName?: string | null;
  contactPersonName?: string | null;
  email?: string | null;
  phoneNumber?: string | null;
  taxId?: string | null;
  registrationNumber?: string | null;
  streetAddress?: string | null;
  city?: string | null;
  state?: string | null;
  postalCode?: string | null;
  country?: string | null;
  notes?: string | null;
  active: boolean;
  createdAt?: string | null;
  updatedAt?: string | null;
  driverCount: number;
  driver?: CustomerAccountDriverSummary | null;
  driverDetails?: DriverRecord | null;
  linkedDrivers: CustomerAccountDriverSummary[];
}

export interface CustomerAccountSaveRequest {
  type: CustomerType;
  displayName: string;
  legalName?: string;
  contactPersonName?: string;
  email?: string;
  phoneNumber?: string;
  taxId?: string;
  registrationNumber?: string;
  streetAddress?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  country?: string;
  notes?: string;
  active?: boolean;
  driverId?: number | null;
  driver?: DriverSaveRequest | null;
}

export const createEmptyCustomerAccountForm = (): CustomerAccountSaveRequest => ({
  type: 'PERSON',
  displayName: '',
  legalName: '',
  contactPersonName: '',
  email: '',
  phoneNumber: '',
  taxId: '',
  registrationNumber: '',
  streetAddress: '',
  city: '',
  state: '',
  postalCode: '',
  country: '',
  notes: '',
  active: true,
  driverId: null,
  driver: null,
});
